export default __webpack_public_path__ + "static/media/pelota-futbol.69d577a7.png";